// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file responses/v1/all_shipping_rate_definition_response.proto (package responses.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import { file_responses_v1_country_response } from './country_response_pb';
import { file_settings_v1_shipping_rate_definition_type } from '../../settings/v1/shipping_rate_definition_type_pb';
import type { ShippingRateDefinitionResponse } from './shipping_rate_definition_response_pb';
import { file_responses_v1_shipping_rate_definition_response } from './shipping_rate_definition_response_pb';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file responses/v1/all_shipping_rate_definition_response.proto.
 */
export const file_responses_v1_all_shipping_rate_definition_response: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CjhyZXNwb25zZXMvdjEvYWxsX3NoaXBwaW5nX3JhdGVfZGVmaW5pdGlvbl9yZXNwb25zZS5wcm90bxIMcmVzcG9uc2VzLnYxImYKIUFsbFNoaXBwaW5nUmF0ZURlZmluaXRpb25SZXNwb25zZRJBCgtkZWZpbml0aW9ucxgBIAMoCzIsLnJlc3BvbnNlcy52MS5TaGlwcGluZ1JhdGVEZWZpbml0aW9uUmVzcG9uc2VCkQEKEGNvbS5yZXNwb25zZXMudjFCJkFsbFNoaXBwaW5nUmF0ZURlZmluaXRpb25SZXNwb25zZVByb3RvUAFaBC4vcGKiAgNSWFiqAgxSZXNwb25zZXMuVjHKAgxSZXNwb25zZXNcVjHiAhhSZXNwb25zZXNcVjFcR1BCTWV0YWRhdGHqAg1SZXNwb25zZXM6OlYxYgZwcm90bzM',
        [
            file_responses_v1_country_response,
            file_settings_v1_shipping_rate_definition_type,
            file_responses_v1_shipping_rate_definition_response,
        ]
    );

/**
 * @generated from message responses.v1.AllShippingRateDefinitionResponse
 */
export type AllShippingRateDefinitionResponse = Message<'responses.v1.AllShippingRateDefinitionResponse'> & {
    /**
     * @generated from field: repeated responses.v1.ShippingRateDefinitionResponse definitions = 1;
     */
    definitions: ShippingRateDefinitionResponse[];
};

/**
 * Describes the message responses.v1.AllShippingRateDefinitionResponse.
 * Use `create(AllShippingRateDefinitionResponseSchema)` to create a new message.
 */
export const AllShippingRateDefinitionResponseSchema: GenMessage<AllShippingRateDefinitionResponse> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_all_shipping_rate_definition_response, 0);
